export default "__VITE_ASSET__Db$_Trbd__"